const translations = {
  "en": {
    " in the App Store now.": " in the App Store now.",
    "One last step...": "One last step...",
    "please manually cancel your old subscription": "please manually cancel your old subscription",
    "Your Lifetime plan is active! To avoid any future charges,": "Your Lifetime plan is active! To avoid any future charges,"
  },
  "zh-tw": {
    " in the App Store now.": "。",
    "One last step...": "最後一步...",
    "please manually cancel your old subscription": "手動取消你的舊訂閱",
    "Your Lifetime plan is active! To avoid any future charges,": "你的終身方案已啟用！為避免日後產生費用，請立即前往 App Store"
  }
};

export default translations;
